const _h = {
  dumpObj: v => JSON.stringify(v, null, 4),
  clone: src => {
    let out, v, k
    if (typeof src !== 'object' || src === null) {
      return src
    }
    out = Array.isArray(src) ? [] : {}
    for (k in src) {
      v = src[k]
      out[k] = _h.clone(v)
    }
    return out
  },
  trimStr: v => v.replace(/^\s\s*/, '').replace(/\s\s*$/, ''),
  parsePath: v => {
    let r = v.split('/')
    if (r.length && r[r.length - 1] === '') r.pop()
    return r
  },
  formatPrice: v => {
    // 13935 -> 13&nbsp;935
    let m = `${v}`.match(/^([0-9]{1,3})([0-9]{3})$/)
    if (m) {
      return `${m[1]} ${m[2]}`
    }
    return v
  },
  formatDate: v => {
    const dt = new Date(v)
    let d = dt.getDate()
    if (d < 10) d = `0${d}`
    let m = dt.getMonth() + 1
    if (m < 10) m = `0${m}`
    let y = dt.getFullYear()
    return `${d}.${m}.${y}`
  },
  parseFalsy: v => {
    return v === '' || v.match(/^false|0|null|no$/i) ? false : true
  },
  isNumeric: v => {
    const t = typeof v
    return t === 'number' ? true : t === 'string' ? t.match(/^\d+$/) : false
  },
  id: v => {
    return document.getElementById(v)
  },
  q: v => {
    return document.querySelector(v)
  },
  env: (k, def) => {
    return typeof process.env[k] !== 'undefined'
      ? process.env[k]
      : typeof def !== 'undefined'
      ? def
      : ''
  },
  fixChildren: list => {
    if (!Array.isArray(list)) list = []
    list.forEach(item => {
      if (typeof item.children === 'undefined') {
        item.children = []
      } else {
        _h.fixChildren(item.children)
      }
    })
  },
  fixProducts: list => {
    if (!Array.isArray(list)) list = []
    list.forEach(item => {
      if (!Array.isArray(item.products)) {
        item.products = []
      }
      // todo fix products
      // item.products.forEach(p => p)
      if (typeof item.children === 'undefined') {
        _h.fixProducts(item.children)
      }
    })
  },
  stripHTML: v => {
    return v.replace(/<\/?[^>]+>/gi, '')
  },
  toSlug: v => {
    let r = '' + v
    r = r.toLowerCase().replace(' ', '-')
    if (r === 'да') r = 'yes'
    if (r === 'нет') r = 'no'
    return r
  },
  gtmDataLayerPush: content => {
    const dataLayer = (window.dataLayer = window.dataLayer || [])
    dataLayer.push(content)
    console.info('[GTM]', 'dataLayer', window.dataLayer, content)
  },
  getCanonical() {
    return `${window.location.origin}${window.location.pathname}${window.location.search}`
  },
  updateCanonicalLink() {
    const head = document.head.querySelector('link[rel="canonical"]')
    const canonicalHref = this.getCanonical()
    head.setAttribute('href', canonicalHref)
  },
  getAlt(text) {
    return `${text} - apptown.com.ua`
  },
}
module.exports = _h
